import { useSnackbar } from "notistack";
import React, { useCallback, useState, useEffect } from "react";
import { BiEditAlt } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import {
  ACTIVATE,
  ACTIVE,
  ADD_SERVICE_ACL,
  CLIENTS_DEACTIVATE_ACCOUNT_ACL,
  CLIENT_EDIT_ACL,
  CLIENT_EDIT_SUB_ACL,
  DEACTIVATE,
  INACTIVE,
  PENDING,
  RESELLER,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import CustomTabs from "../../../../components/main_comps/custom_tabs";
import MainComponent from "../../../../components/ui_comps/MainComponent";
import BankAccountDetails from "./BankAccountDetails";
import BasicDetails from "./BasicDetails";
import ClientsDocument from "./ClientsDocument";
import OtherDetails from "./OtherDetails";
import { useSelector } from "react-redux";
import { SS_ROLE } from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";
import { validateEmail } from "../../../../../utility/emailValidator";
import TransactionLimits from "./TransactionLimits";
import CustomModal from "../../../../components/main_comps/custom_modal";
import CheckBoxInput from "../../../../components/ui_comps/CheckBoxInput";
import AlertModals from "../../../../components/ui_comps/AlertModals";
import {
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";

const tabs = [
  { name: "Basic Details", key: 0 },
  { name: "Bank account Details", key: 1 },
  { name: "Documents", key: 2 },
  { name: "Transaction Limits", key: 3 },
  { name: "Other Details", key: 4 },
];
const tabs1 = [{ name: "Basic Details", key: 0 }];

const ActionComponent = ({
  onClickDeactivate,
  loading,
  status,
  step,
  onClickEdit,
  isEditClicked,
  onClickSave,
  aclData,
  data,
}) => {
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex" }}>
      {aclData?.includes(CLIENT_EDIT_SUB_ACL) &&
        aclData?.includes(CLIENT_EDIT_ACL) && (
          <CustomButton
            styles={{
              backgroundColor: "white",
              border: "1px solid #1E2234",
              cursor: "pointer",
            }}
            title={"Edit Acl"}
            textStyles={{ color: "#1E2234" }}
            onClick={() => {
              navigate("/clients/edit-acl", {
                state: { data },
              });
            }}
          />
        )}

      {aclData?.includes(CLIENTS_DEACTIVATE_ACCOUNT_ACL) && !isEditClicked && (
        <CustomButton
          styles={{
            backgroundColor: "white",
            border: "1px solid #1E2234",
            marginLeft: "20px",

            cursor: status === PENDING ? "not-allowed" : "pointer",
          }}
          title={
            status === PENDING
              ? "Pending..."
              : status === INACTIVE
              ? "Activate"
              : "Deactivate account"
          }
          textStyles={{ color: "#1E2234" }}
          onClick={() => onClickDeactivate(true)}
          loading={loading}
          disabled={status === PENDING ? true : false}
        />
      )}

      {aclData?.includes(ADD_SERVICE_ACL) && (
        <CustomButton
          title="Add services"
          styles={{
            marginLeft: "20px",
          }}
          onClick={() => {
            navigate("/clients/addservice", {
              state: { data },
            });
          }}
        />
      )}

      {(step === 0 || step === 1 || step === 3) && (
        <>
          {aclData?.includes(CLIENT_EDIT_ACL) && (
            <CustomButton
              ionDirection="left"
              icon={
                isEditClicked ? null : <BiEditAlt size={16} color="white" />
              }
              styles={{
                backgroundColor: isEditClicked ? "transparent" : "#38369C",
                border: isEditClicked
                  ? "1px solid #1E2234"
                  : "1px solid #38369C",
                marginLeft: "10px",
              }}
              title={isEditClicked ? "Cancel" : "Edit"}
              textStyles={{ color: isEditClicked ? "#1E2234" : "white" }}
              onClick={onClickEdit}
            />
          )}
          {isEditClicked && (
            <CustomButton
              ionDirection="left"
              icon={<BiEditAlt size={16} color="white" />}
              styles={{
                backgroundColor: "#38369C",
                border: "1px solid #38369C",
                marginLeft: "10px",
              }}
              title={"Save"}
              textStyles={{ color: "white" }}
              onClick={onClickSave}
            />
          )}
        </>
      )}
    </div>
  );
};

const ClientDetailsIndex = ({}) => {
  const [currentTab, setCurrentTab] = useState(0);
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [isEditClicked, setIsEditClicked] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [clientDetails, setClientDetails] = useState({});

  const aclData = useSelector((state) => state.aclSlice.aclList);
  const role = secureStorage.getItem(SS_ROLE);
  const [openSetStatusModal, setOpenSetStatusModal] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [services, setServices] = useState("all");
  const [reason, setReason] = useState("");
  const [payin, setPayin] = useState("");
  const [payout, setPayout] = useState("");
  const [van, setVan] = useState("");
  const [vanUpi, setVanUpi] = useState("");
  const [voucher, setVoucher] = useState("");
  const [checked, setChecked] = useState(false);
  const [servicetype, setServiceType] = useState("");
  const [payinsubcoreStatus, setPayinCoreStatus] = useState("");
  const [payoutSubcoreStatus, setPayoutSubcoreStatus] = useState("");
  const [vanSubcoreStatus, setVanSubcoreStatus] = useState("");
  const [vanUpiSubcoreStatus, setVanUpiSubcoreStatus] = useState("");
  const [voucherSubcoreStatus, setVoucherSubcoreStatus] = useState("");
  const [clientData, setClientData] = useState({});

  const handleChange = (event) => {
    if (event.target.value === "payin") {
      setPayinCoreStatus(!payin?.status);
    }
    if (event.target.value === "payout") {
      setPayoutSubcoreStatus(!payout?.status);
    }
    if (event.target.value === "van") {
      setVanSubcoreStatus(!van?.status);
    }
    if (event.target.value === "van-upi") {
      setVanUpiSubcoreStatus(!vanUpi?.status);
    }
    if (event.target.value === "voucher") {
      setVoucherSubcoreStatus(!voucher?.status);
    }

    if (event.target.checked) {
      setChecked(true);
      setServiceType(event.target.value);
    } else {
      setChecked(false);
    }
  };

  const handleTabChange = useCallback((tab) => {
    setCurrentTab(tab);
  }, []);

  const onClickEditClient = () => {
    if (
      clientDetails?.mobileNumber &&
      clientDetails?.mobileNumber.length != 10
    ) {
      enqueueSnackbar("Invalid Mobile Number", {
        variant: "error",
      });
      return;
    }

    if (clientDetails?.email && !validateEmail(clientDetails?.email)) {
      enqueueSnackbar("Invalid email id", {
        variant: "error",
      });
      return;
    }
    if (
      clientDetails?.remitterAccountNumber &&
      clientDetails?.remitterAccountNumber.length < 9
    ) {
      enqueueSnackbar("Invalid account Number", {
        variant: "error",
      });
      return;
    }
    if (
      clientDetails?.accountNumber &&
      clientDetails?.accountNumber.length < 9
    ) {
      enqueueSnackbar("Invalid account Number", {
        variant: "error",
      });
      return;
    }
    if (
      clientDetails?.remitterAccountIfsc &&
      clientDetails?.remitterAccountIfsc.length != 11
    ) {
      enqueueSnackbar("Invalid ifsc code", {
        variant: "error",
      });
      return;
    }

    if (clientDetails?.ifscCode && clientDetails?.ifscCode.length != 11) {
      enqueueSnackbar("Invalid ifsc code", {
        variant: "error",
      });
      return;
    }

    if (
      clientDetails?.remitterAccountNumber &&
      !clientDetails?.accountValidate
    ) {
      enqueueSnackbar("Please verify remitter account", {
        variant: "error",
      });
      return;
    }

    // if (
    //   clientDetails?.accountNumber &&
    //   !clientDetails?.settlementAccountValidate
    // ) {
    //   enqueueSnackbar("Please verify settlement account", {
    //     variant: "error",
    //   });
    //   return;
    // }

    ApiRequestPost.editClientUser({
      email: clientDetails?.email,
      firstName: clientDetails?.firstName,
      lastName: clientDetails?.lastName,
      mobileNumber: clientDetails?.mobileNumber,
      panNumber: clientDetails?.panNumber,
      userId: state?.data?.userId,
      userRefId: state?.data?.userRefId,
      accountHolderName: clientDetails?.nameAsPerBank,
      accountNumber: clientDetails?.accountNumber,
      ifscCode: clientDetails?.ifscCode,
      remitterAccountName: clientDetails?.remitterAccountName,
      remitterAccountNumber: clientDetails?.remitterAccountNumber,
      remitterAccountIfsc: clientDetails?.remitterAccountIfsc,
      reservePercentage: clientDetails?.reservePercentage ?? "",
      reserveAmount: clientDetails?.reserveAmount,
      debitorAccNumber: clientDetails?.debitorAccountNumber ?? "",
      corpId: clientDetails?.corpId,
      // reserveStatus: clientDetails?.reserveStatus,
      securityAmount: clientDetails?.securityAmount ?? "",
      industryType: clientDetails?.industryType,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          navigate("/clients");
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
      });
  };

  const onClickChangeStatusOfClient = (
    status,
    clientId,
    reason = "",
    services
  ) => {
    setLoading(true);

    ApiRequestPost.approveRejectActionStatus({
      status,
      clientId,
      reason,
      service:
        services === "all"
          ? ""
          : [
              {
                serviceProviderName:
                  servicetype === "payout"
                    ? payout?.serviceProviderName
                    : servicetype === "van"
                    ? van.serviceProviderName
                    : servicetype === "van-upi"
                    ? vanUpi.serviceProviderName
                    : servicetype === "voucher"
                    ? voucher.serviceProviderName
                    : payin?.serviceProviderName,

                status:
                  servicetype === "payout"
                    ? payoutSubcoreStatus
                    : servicetype === "van"
                    ? vanSubcoreStatus
                    : servicetype === "van-upi"
                    ? vanUpiSubcoreStatus
                    : servicetype === "voucher"
                    ? voucherSubcoreStatus
                    : payinsubcoreStatus,
                serviceType: servicetype,
              },
            ],
      deactivateSubCore: services === "all" ? "" : true,
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });

          setConfirm(false);
          setOpenSetStatusModal(false);
          navigate("/clients");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setIsEditClicked(false);
    setClientDetails({});
  }, [currentTab]);

  useEffect(() => {
    if (state?.data) {
      setClientData(state.data);
      const payoutService = state?.data?.service.find(
        (e) => e.serviceType === "payout"
      );
      const payinService = state?.data?.service.find(
        (e) => e.serviceType === "payin"
      );
      const vanService = state?.data?.service.find(
        (e) => e.serviceType === "van"
      );
      const vanUpiService = state?.data?.service.find(
        (e) => e.serviceType === "van-upi"
      );
      const voucherService = state?.data?.service.find(
        (e) => e.serviceType === "voucher"
      );

      setPayout(payoutService);
      setPayin(payinService);
      setVan(vanService);
      setVoucher(voucherService);
      setVanUpi(vanUpiService);
    }
  }, [state?.data]);

  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        filterRequired={false}
        backActionRequired={true}
        headerTitle={state?.data?.firstName + " " + state?.data?.lastName}
      />
      <CustomTabs
        tabs={role === RESELLER ? tabs1 : tabs}
        backgroundrequired={false}
        activeIndex={currentTab}
        passCurrentTab={(data) => handleTabChange(data)}
        actionComponent={
          <ActionComponent
            onClickDeactivate={(val) => {
              setConfirm(val);
            }}
            status={state?.data?.activeStatus}
            loading={loading}
            step={currentTab}
            data={state?.data}
            onClickEdit={() => {
              setIsEditClicked(!isEditClicked);
            }}
            isEditClicked={isEditClicked}
            onClickSave={() => {
              if (Object.keys(clientDetails).length > 0) {
                onClickEditClient();
              }
            }}
            aclData={aclData}
          />
        }
      />

      {role === RESELLER ? (
        currentTab === 0 ? (
          <BasicDetails
            data={clientData}
            isEditClicked={isEditClicked}
            onChange={(val) => {
              setClientDetails({ ...val });
            }}
          />
        ) : (
          <></>
        )
      ) : currentTab === 0 ? (
        <BasicDetails
          data={clientData}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...val });
          }}
        />
      ) : currentTab === 1 ? (
        <BankAccountDetails
          data={clientData}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...clientDetails, ...val });
          }}
          apicall={onClickEditClient}
        />
      ) : currentTab === 2 ? (
        <ClientsDocument data={clientData} />
      ) : currentTab === 3 ? (
        <TransactionLimits
          data={clientData}
          isEditClicked={isEditClicked}
          onChange={(val) => {
            setClientDetails({ ...val });
          }}
        />
      ) : (
        <OtherDetails data1={clientData} />
      )}

      {confirm && (
        <CustomModal
          headerTitle=""
          open={confirm}
          onClose={() => {
            setConfirm(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <p
            style={{
              color: primaryColor,
              fontWeight: "500",
              marginBottom: 30,
            }}
          >
            {`Select the Services to be ${
              state?.data?.activeStatus === ACTIVE
                ? "deactivate/activate"
                : "activate/deactivate"
            }`}
          </p>
          <div
            style={{
              display: "flex",
              width: "50%",
              border: "1px solid #ECECEC",
            }}
          >
            <div
              style={{
                flex: 1,
                padding: "10px 0px",
                textAlign: "center",
                fontSize: 14,
                borderRight: "1px solid #ECECEC",
                backgroundColor: services === "all" ? "#ECECEC" : "",
              }}
              onClick={() => {
                setServices("all");
                setChecked(false);
              }}
            >
              All
            </div>
            {payin && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "payin" ? "#ECECEC" : "",
                  borderRight: "1px solid #ECECEC",
                }}
                onClick={() => {
                  setServices("payin");
                  setChecked(false);
                }}
              >
                Pay in
              </div>
            )}
            {payout && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "payout" ? "#ECECEC" : "",
                }}
                onClick={() => {
                  setServices("payout");
                  setChecked(false);
                }}
              >
                Pay out
              </div>
            )}
            {van && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "van" ? "#ECECEC" : "",
                }}
                onClick={() => {
                  setServices("van");
                  setChecked(false);
                }}
              >
                Van
              </div>
            )}
            {vanUpi && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "van-upi" ? "#ECECEC" : "",
                }}
                onClick={(e) => {
                  setServices("van-upi");
                  setChecked(false);
                }}
              >
                Van Upi
              </div>
            )}
            {voucher && (
              <div
                style={{
                  flex: 1,
                  padding: "10px 0px",
                  textAlign: "center",
                  fontSize: 14,
                  backgroundColor: services === "voucher" ? "#ECECEC" : "",
                }}
                onClick={() => {
                  setServices("voucher");
                  setChecked(false);
                }}
              >
                Voucher
              </div>
            )}
          </div>

          {services === "all" && (
            <CheckBoxInput
              title={"All"}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "payout" && (
            <CheckBoxInput
              title={payout?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "payin" && (
            <CheckBoxInput
              title={payin?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "van" && (
            <CheckBoxInput
              title={van?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "van-upi" && (
            <CheckBoxInput
              title={vanUpi?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}
          {services === "voucher" && (
            <CheckBoxInput
              title={voucher?.serviceProviderName}
              value={services}
              onChange={handleChange}
            />
          )}

          <div
            style={{
              display: "flex",
              gap: 20,
              justifyContent: "center",
              marginTop: 30,
            }}
          >
            <CustomButton
              title={"continue"}
              styles={{
                backgroundColor: primaryColor,
                border: "none",
                padding: 0,
                height: "auto",
                padding: "15px 40px",
              }}
              textStyles={{
                color: colorWhite,
              }}
              onClick={() => {
                if (
                  services === "all" ||
                  services === "payin" ||
                  services === "payout" ||
                  services === "van" ||
                  services === "van-upi" ||
                  services === "voucher"
                ) {
                  if (checked) {
                    setOpenSetStatusModal(true);
                  } else {
                    enqueueSnackbar("Please select any field", {
                      variant: "error",
                    });
                  }
                }
              }}
              disabled={false}
              loading={loading}
            />
          </div>
        </CustomModal>
      )}
      {openSetStatusModal && (
        <CustomModal
          headerTitle=""
          open={openSetStatusModal}
          onClose={() => {
            setOpenSetStatusModal(false);
          }}
          containerStyle={styles.modalContainerStyle}
        >
          <AlertModals
            onClickCancel={() => setOpenSetStatusModal(false)}
            confirmButtonTitle={"Yes"}
            onClickOk={(reason) => {
              if (reason) {
                setReason(reason);
                if (services === "all") {
                  onClickChangeStatusOfClient(
                    state?.data?.activeStatus === ACTIVE
                      ? DEACTIVATE
                      : ACTIVATE,
                    state?.data?.userId,
                    reason,
                    services
                  );
                } else {
                  onClickChangeStatusOfClient("", state?.data?.userId, reason);
                }
              } else {
                enqueueSnackbar(
                  `Please enter reason for ${
                    state?.data?.activeStatus === ACTIVE
                      ? "Deactivate/Activate"
                      : "Activate/Deactivate"
                  }`,
                  {
                    variant: "error",
                  }
                );
              }
            }}
            loading={loading}
            action={
              state?.data?.activeStatus === ACTIVE
                ? "Deactivate/Activate"
                : "Activate/Deactivate"
            }
            reason={
              state?.data?.activeStatus === ACTIVE
                ? "Deactivating/Activating"
                : "Activating/Deactivating"
            }
            data={state?.data}
          />
        </CustomModal>
      )}
    </div>
  );
};
const styles = {
  modalContainerStyle: {
    minWidth: 350,
    maxWidth: 450,
    height: "auto",
    maxHeight: 800,
  },
};

export default ClientDetailsIndex;
